<template>
	<v-card class="mb-4" v-show="data.length > 0" v-if="data.length > 0">
		<v-card-title>
			Таблица данных
			<v-spacer></v-spacer>
			<v-text-field
				v-model="tableSearch"
				append-icon="mdi-magnify"
				label="Фильтр"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			v-model="selectedItems"
			:headers="tableHeaders"
			:items="data"
			:items-per-page="100"
			:footer-props="{
				'disable-items-per-page': true
			}"
			:search="tableSearch"
			no-results-text="Нет данных"
			multi-sort
			show-select
			show-expand
			@item-expanded="getFullText"
		>
		<template v-slot:item.id="{ item }">
			{{ item.id }}<span :ref="`full_text_${item.id}`"></span>
		</template>
		<template v-slot:expanded-item="{ headers, item }">
			<td :colspan="headers.length">
				<v-progress-linear color="primary" buffer-value="0" stream v-if="!item.full_text"></v-progress-linear>
				<section class="full_text pt-5 pb-5" v-if="item.full_text" v-html="item.full_text"></section>
			</td>
		</template>
		<template v-slot:item.actions="{ item }">
			<v-icon small @click="showConfirmDeleteDialog(item.id, true)">
				mdi-delete
			</v-icon>
			<v-dialog v-model="confirmDeleteDialog[item.id]" max-width="290">
				<v-card>
					<v-card-title class="headline">Удалить запись?</v-card-title>
					<v-card-text>Вы действительно хотите удалить запись <b>№{{ item.id }}</b> без возможности восстановления?</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="green darken-1" text @click="showConfirmDeleteDialog(item.id, false)">
							Отмена
						</v-btn>
						<v-btn color="red darken-1" text @click="showConfirmDeleteDialog(item.id, false); deleteItem(item)">
							Удалить
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</template>
		</v-data-table>
	</v-card>
</template>

<script>
export default {
	name:"Table",
	props: { data: { default:null }, dummyData:{ default:false } },
	data: () => ({
		tableHeaders:[
			{ text:"ID", value:"id", align:"start" },
			{ text:"Содержание", value:"text_preview", align:"start" },
			{ text:"Слова (количество)", value:"words_num", align:"start" },
			{ text:"Символы (количество)", value:"symbols_num", align:"start" },
			{ text:"Предложения (энтропия)", value:"sentences.entropy", align:"start" },
			{ text:"Предложения (сложность)", value:"sentences.complexity", align:"start" },
			{ text:"Размер предложений (энтропия)", value:"sentences_size.entropy", align:"start" },
			{ text:"Размер предложений (сложность)", value:"sentences_size.complexity", align:"start" },
			{ text:"Слова (энтропия)", value:"words.entropy", align:"start" },
			{ text:"Слова (сложность)", value:"words.complexity", align:"start" },
        	{ text:'Удалить', value:'actions', sortable: false },
		], tableSearch:'', selectedItems:[]
	}),
	computed: {
		confirmDeleteDialog(){
			let arr = {}
			this.data.forEach((p, idx) => arr[p.id] = false)
			return arr
		}
	},
	created(){
		this.$eventBus.$on('scatter_click', entryId => {
			try {
				let idx = this.data.find(entry => entry.id == entryId).id
				let parent = this.$refs[`full_text_${idx}`].parentElement.parentElement
				window.scrollTo(0,parent.getBoundingClientRect().top)
				parent.querySelector('button').click()
			} catch(e){
				console.log('api needed')
			}
		})
	},
	methods: {
		deleteItem(item){
			this.$eventBus.$emit('remove_text', this.selectedItems.length > 0 ? this.selectedItems : [item])
		},
		// this method is needed to show/hide the needed
		// dialog from an array of items' dialogs
		showConfirmDeleteDialog(idx, val){
			this.$set(this.confirmDeleteDialog, idx, val)
			this.$forceUpdate()
		},
		getFullText(data){
			if(data.value && !data.item.full_text){
				this.$api.get(`texts/${this.dummyData ? 'demo/' : ''}${data.item.id}/`)
					.then(resp => {
						data.item.full_text = resp.data.text
						this.$forceUpdate()
					})
			}
		}
	}
}
</script>

<style lang="scss">
	.full_text { max-height:300px; overflow-y:auto }
</style>